import { useState } from 'react';
import { Button } from 'src/components';
import styles from './styles.module.scss';

type RunPromptCardProps = {
  userEmail?: string;
  onDone: () => void;
  onSkip?: () => void;
  /** Override the default suggested prompt. */
  prompt?: string;
  title?: string;
  description?: string;
  reminder?: string;
};

export function buildSuggestedPrompt(userEmail?: string): string {
  return `Use FileSpin, search for all sample assets, create a branded share page for review, and send the link to ${userEmail || 'me'}`;
}

export function buildInAppSuggestedPrompt(userEmail?: string): string {
  return `Search for all sample assets, create a branded share page for review, and send the link to ${userEmail || 'me'}`;
}

const RunPromptCard = ({
  userEmail,
  onDone,
  onSkip,
  prompt,
  title = 'Try your first AI workflow',
  description = 'Use this prompt in your AI app to see FileSpin Agentic DAM in action.',
  reminder = 'After running the prompt, check your email for the share link, visit the share page to see the result, then come back here to continue onboarding.',
}: RunPromptCardProps) => {
  const [copied, setCopied] = useState(false);
  const suggestedPrompt = prompt || buildSuggestedPrompt(userEmail);

  const handleCopy = () => {
    navigator.clipboard.writeText(suggestedPrompt).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    });
  };

  return (
    <>
      <div className={styles.guideHeader}>
        <h2>{title}</h2>
        <p>{description}</p>
      </div>

      <div className={styles.promptCard}>
        <div className={styles.promptHeader}>
          <h4>Suggested prompt</h4>
          <button
            type="button"
            className={styles.promptCopy}
            onClick={handleCopy}
          >
            {copied ? 'Copied!' : 'Copy'}
          </button>
        </div>
        <blockquote>{suggestedPrompt}</blockquote>
      </div>

      <div className={styles.promptReminder}>{reminder}</div>

      <div className={styles.guideCta}>
        <Button onClick={onDone}>I've run the prompt</Button>
        {onSkip && (
          <Button mode="tertiary" onClick={onSkip}>
            Skip
          </Button>
        )}
      </div>
    </>
  );
};

export default RunPromptCard;
